import React from 'react';
import PropTypes from 'prop-types';

import { StepButton } from './Stepper.styled';

const Step = ({ title, isActive, className, isClickable, onStepClick }) => (
  <li>
    <StepButton
      className={className}
      isActive={isActive}
      isClickable={isClickable}
      onClick={isClickable ? onStepClick : null}
      tabIndex={isClickable && !isActive ? 0 : -1}
      type="button"
      disabled={!isClickable}
    >
      {title}
    </StepButton>
  </li>
);

Step.defaultProps = {
  className: '',
  onStepClick: null,
};

Step.propTypes = {
  title: PropTypes.node.isRequired,
  isActive: PropTypes.bool.isRequired,
  isClickable: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onStepClick: PropTypes.func,
};

export default Step;
